import cx from 'classnames';

import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';

import styles from './ResetPassword.module.scss';

const EmailSuccess = () => {
  const layout = useLayout();

  return (
    <div className={cx(styles.content, styles.center, styles[layout])}>
      <h3 className={styles.title}>
        <Translation message="success" />
      </h3>
      <p className={styles.description}>
        <Translation message="your_password_is_reseted_check_your_email_for_link_to_set_new_password" />
      </p>
    </div>
  );
};

export default EmailSuccess;
